import { ReactElement } from 'react';

import { VisitEncounterMode, VisitUpdateEncounterModeCommand } from '@dreryk/egabinet-visit-frontend-api';

import { MapMarkerIcon, VideoConsultationIcon } from '@dreryk/react-components';
import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';

import { visitTranslationKeys } from '../../translations';

import { VideoConsultationDropdownItem } from './items/VideoConsultationDropdownItem';
import { OnSiteDropdownItem } from './items/OnSiteDropdownItem';

const t = visitTranslationKeys.controlsBar.visitEncounterMode;

type UseVisitUpdatEncounterModeCommandOptions = {
   visitId: number;
   onSuccess: (visitEncounterMode: VisitEncounterMode) => void;
};

export const useVisitUpdateEncounterModeCommand = (
   options: UseVisitUpdatEncounterModeCommandOptions
): UseCqrsCommandResult<void, VisitEncounterMode> => {
   return useCqrsCommand<void, VisitEncounterMode>(
      (visitEncounterMode) => {
         const command = new VisitUpdateEncounterModeCommand();
         command.id = options.visitId;
         command.encounterMode = visitEncounterMode;
         return command;
      },
      {
         onSuccess: (__, visitEncounterMode) => {
            options.onSuccess(visitEncounterMode);
         },
      }
   );
};

type DropdownItemsConfiguration = Record<VisitEncounterMode, DropdownItem>;
type DropdownItem = { iconTestId: string; icon: ReactElement; label: string; item: ReactElement };

type OnUpdateVisitEncounterMode = (visitEncounterMode: VisitEncounterMode) => Promise<void>;

type UseVisitEncounterModeDropdownItemsConfigurationOptions = {
   onUpdateVisitEncounterMode: OnUpdateVisitEncounterMode;
   patientId: number;
};
type UseVisitEncounterModeDropdownItemsConfigurationReturn = DropdownItemsConfiguration;

export const useVisitEncounterModeDropdownItemsConfiguration = (
   options: UseVisitEncounterModeDropdownItemsConfigurationOptions
): UseVisitEncounterModeDropdownItemsConfigurationReturn => ({
   ON_SITE: {
      iconTestId: 'mapMarker',
      icon: <MapMarkerIcon />,
      label: t.ON_SITE,
      item: <OnSiteDropdownItem key={'mapMarker'} onClick={options.onUpdateVisitEncounterMode} />,
   },
   VIDEO_CONSULTATION: {
      iconTestId: 'videoConsultation',
      icon: <VideoConsultationIcon />,
      label: t.VIDEO_CONSULTATION,
      item: (
         <VideoConsultationDropdownItem
            key={'videoConsultation'}
            onClick={options.onUpdateVisitEncounterMode}
            patientId={options.patientId}
         />
      ),
   },
});
